import * as React from "react";
const SvgConnectedProfile = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-c2ec612c-ea01-4c85-bccf-8d5a2562d316", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 7.75, style: {
  fill: "#69cc73",
  stroke: "#2f3232",
  strokeWidth: ".5px"
} }));
export default SvgConnectedProfile;
